import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SelectLocationDisplaysModalViewModel } from './select-location-displays-modal-view-model';
import { BaseModalComponent } from '../../../../../models/base/base-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-select-location-displays-modal',
  templateUrl: './select-location-displays-modal.component.html',
  styleUrls: ['./select-location-displays-modal.component.scss'],
  providers: [SelectLocationDisplaysModalViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SelectLocationDisplaysModalComponent extends BaseModalComponent {
  constructor(
    public viewModel: SelectLocationDisplaysModalViewModel,
    activeModel: NgbActiveModal
  ) {
    super(activeModel);
    this.viewModel.dismissModalSubject.subscribeWhileAlive({
      owner: this,
      next: () => this.close(null)
    });
  }
}
